import {createModelSchema, primitive, identifier,} from 'serializr';

export class Product {
    id!: number;
    rodzaj!: string;
    link!: string;
    data_uruchomienia!: Date;
    data_wygasniecia!: Date;
    blokada_konfiguracji!: boolean;
    blokada!: boolean;
    id_opp!: number;
    nazwa_opp!: string;
    nazwa!: string;
}

createModelSchema(Product, {
    id: identifier(),
    rodzaj: primitive(),
    link: primitive(),
    data_uruchomienia: primitive(),
    data_wygasniecia: primitive(),
    blokada_konfiguracji: primitive(),
    blokada: primitive(),
    id_opp:  primitive(),
    nazwa_opp:  primitive(),
    nazwa:  primitive(),
});
